import { ApiProperty } from "@nestjs/swagger";
export class WorkStationIdReq{
    workstationId:number;
    unitId:number
    constructor(workstationId:number,unitId:number){
        this.workstationId = workstationId;
        this.unitId = unitId;
    }
}